import React from "react";
import classnames from "classnames";

import "./vertical-stepper.css";

const Indicator = ({ hidden, completed, isProfile }) => {
  return (
    <div
      className={classnames(
        "step",
        completed && "step-completed",
        completed && "line-completed"
      )}
    >
      <div class="lineUpper" style={{ visibility: hidden && "hidden" }}></div>
      <div className="circle"></div>
      <div className="line"></div>
    </div>
  );
};

export default Indicator;
